import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { TemplateLayoutModel } from '@fi-app/template/template-layout.model';

@Component({
    selector: 'fi-document-template-layout-view',
    templateUrl: './document-template-layout-view.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../document-template-layout.scss'],
    standalone: false,
})
export class FiDocumentTemplateLayoutViewComponent {
    @Input() tplLayout: TemplateLayoutModel;
    @Input() mediaBankFileReferences: IMediaBankFileReference;
}
